import { ArrowRight, DollarSign, Users } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Find Your Customer",
    copy: "We identify exactly who is most likely to buy.",
  },
  {
    n: "02",
    title: "Get Their Attention",
    copy: "We create Meta and Google ads that grab the attention of people most likely to buy from you.",
  },
  {
    n: "03",
    title: "Capture The Lead",
    copy: "Your website, forms and phone line turn that attention into real leads you can talk to.",
  },
  {
    n: "04",
    title: "Follow The Data",
    copy: "We watch what's bringing in the best leads and do more of it.",
  },
  {
    n: "05",
    title: "Scale What Works",
    copy: "When something works, we put more behind it. When it doesn't, we fix it or cut it.",
  },
];

export const Process = () => (
  <section id="how-it-works" className="relative border-y border-white/5 bg-[#07070C] py-12 sm:py-16">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow>The Process</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-extrabold leading-[0.95] tracking-tighter text-white sm:text-5xl lg:text-6xl">
          How We Turn Advertising <span className="text-purple-500">Into Customers</span>
        </h2>
      </Reveal>

      <div className="mt-14 flex items-center gap-3">
        <Reveal className="flex items-center gap-2.5 rounded-full border border-purple-500/40 bg-purple-600/10 px-5 py-2.5">
          <DollarSign className="h-4 w-4 text-purple-400" />
          <span className="text-xs font-extrabold uppercase tracking-[0.15em] text-purple-300">Advertising Goes In</span>
        </Reveal>
        <ArrowRight className="h-5 w-5 shrink-0 text-purple-500" />
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {STEPS.map((s, i) => (
          <div key={s.n} className="relative">
            <Reveal delay={0.07 * i} className="h-full">
              <div
                data-testid={`process-step-${s.n}`}
                className="group h-full rounded-2xl border border-[#272732] bg-[#121217] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-purple-500/50"
              >
                <span className="font-display text-5xl font-extrabold tracking-tighter text-white/10 transition-colors duration-300 group-hover:text-purple-500/40">
                  {s.n}
                </span>
                <h3 className="mt-4 font-display text-lg font-extrabold uppercase tracking-tight text-white">
                  {s.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-zinc-400">{s.copy}</p>
              </div>
            </Reveal>
            {i < STEPS.length - 1 && (
              <ArrowRight className="absolute -right-3.5 top-1/2 z-10 hidden h-6 w-6 -translate-y-1/2 text-purple-500 lg:block" />
            )}
          </div>
        ))}
      </div>

      <div className="mt-6 flex items-center justify-end gap-3">
        <ArrowRight className="h-5 w-5 shrink-0 text-purple-500" />
        <Reveal className="flex items-center gap-2.5 rounded-full border border-purple-500/40 bg-purple-600/10 px-5 py-2.5">
          <Users className="h-4 w-4 text-purple-400" />
          <span className="text-xs font-extrabold uppercase tracking-[0.15em] text-purple-300">Customers Come Out</span>
        </Reveal>
      </div>
    </div>
  </section>
);
